import { useEffect, useState } from "react";
import { OndcService } from "../../../app/core/ondc.service";
import { DataTable } from "../../../components/data-table";
import { IgmDataGridCols } from "./data-grid-cols";
import { useNavigate } from "react-router-dom";
import { getMonthStartAndEndDates } from "../../../app/utility/monthStartEndDate";
import moment from "moment";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";

export const OndcIgmData = () => {
  const { startDate, endDate } = getMonthStartAndEndDates();
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [igmData, setIgmData] = useState<any>();
  const [originalImgData, setOriginalImgData] = useState<any>();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [fromDate, setFromDate] = useState<any>(startDate);
  const [toDate, setToDate] = useState<any>(endDate);
  const initialPayload = { limit: 10, page: 0, DateFrom: startDate, DateTo: endDate }
  const [pageCount, setPageCount] = useState<any>(initialPayload);

  useEffect(() => {
    getOndcIgmData(initialPayload);
  }, []);

  const getOndcIgmData = async (data: any) => {
    setLoading(true);
    try {
      const res = await OndcService.getOndcIgmData(data);
      setLoading(false);
      res.results.forEach((el: any) => {
        el.bap_id = el?.context?.bap_id;
        el.category = el?.message?.issue?.category;
        el.sub_category = el?.message?.issue?.sub_category;
        el.issue_type = el?.message?.issue?.issue_type;
        el.issue_id = el?.message?.issue?.id;
        el.created_dt =  FormatIndianDate(el?.created_dt, "");
        // moment(el?.created_dt).format("DD-MM-YYYY");
        el.ticket_status = <div className={`fw-bold ${el?.message?.issue?.status === "CLOSED" ? "text-danger" : "text-success"}`}>{el?.message?.issue?.status}</div>;
        el.view = (
          <button
            className="px-5 py-1 rounded primary-bg text-white border-0"
            onClick={() => getTicketData(el)}
          >
            View
          </button>
        );
      });
      setIgmData(res);
      setOriginalImgData(res);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getTicketData = (data: any) => {
    navigate(`/dashboard/ondc-igm/${data?._id}`);
  };

  const onSelectPaginator = (data: any) => {
    const pageData = pageCount;
    pageData.page = data;
    setPageCount(pageData);
    getOndcIgmData(pageCount);
  };

  const handleChange = (e: any) => {
    let payload = { limit: 10, page: 0, search: e.target.value, DateFrom: fromDate, DateTo: toDate };
    getOndcIgmData(payload);
    setInputValue(e.target.value);
  }

  const selectFromDate = (e: any) => {
    setFromDate(e.target.value);
  }

  const selectToDate = (e: any) => {
    setToDate(e.target.value)
  }

  const searchData = () => {
    let payload = { limit: 10, page: 0, search: inputValue, DateFrom: fromDate, DateTo: toDate };
    setPageCount(payload);
    getOndcIgmData(payload);
  }

  const handleClose = () => {
    setInputValue("");
    setFromDate(startDate);
    setToDate(endDate);
    setPageCount(initialPayload);
    getOndcIgmData(initialPayload);
  }

  return (
    <div className="container-fluid content-bg-color">
      <h4 className="primary-color fw-bold mt-3">ONDC IGM</h4>
      <div className="row">
        <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search ..." />
        <div className="row mt-2">
          <div className="col-md-5 mb-2 ps-0">
            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
          </div>
          <div className="col-md-5 mb-2">
            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
          </div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={searchData}>Search</button></div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={handleClose}>Clear</button></div>
        </div>
      </div>
      <div className="row ">
        <div className="col-12 px-0">
          {loading && (
            <div className="text-center p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          )}
          {!loading && (
            <>
              <DataTable tableData={igmData} TableCols={IgmDataGridCols}
                pagination={true}
                pageCount={pageCount}
                onSelectPageChange={(e) => onSelectPaginator(e)}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
